import React from "react";
import Slider from "../component/slider";
import Category from "../component/category";
import FreeShipping from "../component/freeshipping";
import Banners from "../component/Banners";

function Home()
{
    return(
        <>
        <Slider />
        <Category />
        <FreeShipping />
        <Banners />
        </>
    );
}
export default Home;